import { render, staticRenderFns } from "./dr-tabs.vue?vue&type=template&id=044d5ed9&scoped=true"
import script from "./dr-tabs.vue?vue&type=script&lang=js"
export * from "./dr-tabs.vue?vue&type=script&lang=js"
import style0 from "./dr-tabs.vue?vue&type=style&index=0&id=044d5ed9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044d5ed9",
  null
  
)

export default component.exports